<script lang="ts">
    
    import { Icon } from "sveltestrap";
    import { SERVICE_URL } from "../environment";

    export let id: string;

</script>
<a href="{SERVICE_URL}/instance/{id}/pdf" target="_blank" class="btn btn-primary btn-sm">
    <Icon name="download" />
</a>